// US-237: Model Pill Selector component (Epic 34)
// Simple pill-style radio group for selecting an AI model from a short list of options.
// Used in the Settings page "Review model" quick-picker.

import React from 'react';

export interface ModelPillOption {
  label: string;
  value: string;
}

interface ModelPillSelectorProps {
  value: string;
  onChange: (value: string) => void;
  options: ModelPillOption[];
}

export function ModelPillSelector({ value, onChange, options }: ModelPillSelectorProps) {
  return (
    <div className="flex flex-wrap gap-2" role="radiogroup">
      {options.map((opt) => {
        const isSelected = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            onClick={() => onChange(opt.value)}
            className={[
              'px-3 py-1.5 rounded-full text-sm font-medium border transition-colors focus:outline-none focus:ring-2 focus:ring-sky-500',
              isSelected
                ? 'bg-sky-600 text-white border-sky-600'
                : 'bg-white text-stone-700 border-stone-300 hover:border-sky-400 hover:text-sky-700 dark:bg-stone-800 dark:text-stone-200 dark:border-stone-600',
            ].join(' ')}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
